module.exports = __webpack_public_path__ + "img/fig11.d729627d.jpg";